import { useQuery, QueryFunction } from 'react-query';
import { getAllRentals, GetRentalsQueries, Rental } from '../../services/apiSLTP/materials/rentals';
import { GetMonthlyRentalTypeParams, getMonthlyRentalTypes, MonthlyRentalType } from '../../services/apiSLTP/materials/rentalTypes';

type UseRentalsQueryOptions = {
    queries?: GetRentalsQueries;
};

const getRentals: QueryFunction<Rental[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseRentalsQueryOptions];
    const { queries } = options;

    const response = await getAllRentals(queries);
    return response.data;
};

export const useRentalsQuery = (options: UseRentalsQueryOptions) => {
    return useQuery(['rentals', options], getRentals);
};

type UseMonthlyRentalTypesQueryOptions = {
    params: GetMonthlyRentalTypeParams;
};

const getMonthlyRentalTypesQuery: QueryFunction<MonthlyRentalType[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseMonthlyRentalTypesQueryOptions];
    const { params } = options;

    const response = await getMonthlyRentalTypes(params);
    return response.data;
};

export const useMonthlyRentalTypesQuery = (options: UseMonthlyRentalTypesQueryOptions) => {
    return useQuery(['monthly rentaltype', options], getMonthlyRentalTypesQuery);
};
